import React, { useState } from 'react';
import './CommonStyles.css';
import {
    CheckCircle, Download, ChevronDown, FileSpreadsheet,
    FileText, Printer, CreditCard, Star, Zap, Package
} from 'lucide-react';

const packages = [
    {
        id: 1, name: 'etPOS', price: '79.99', period: '1 Months', popular: true,
        description: 'etPOS',
        features: ['1 Business Locations', '5 Users', 'Unlimited Products', '1500 Invoices',
            'Accounting Module', 'Max Token usage (AI Assistance)', 'Connector Module', 'Crm Module',
            'WooCommerce Module']
    },
    {
        id: 2, name: 'Data Entry', price: '49.99', period: '1 Months', popular: false,
        description: 'Price Book Managment',
        features: ['1 Business Locations', '3 Users', '3000 Products', '1500 Invoices',
            'Accounting Module']
    },
    {
        id: 3, name: 'Cell Phone', price: '99.00', period: '1 Months', popular: false,
        description: 'Cell Phone',
        features: ['1 Business Locations', '5 Users', '2000 Products', 'Unlimited Invoices',
            'Accounting Module', 'Crm Module', 'Essentials Module', 'Repair Module', 'WooCommerce Module']
    },
    {
        id: 4, name: 'etPOS with 2 Locations', price: '199.00', period: '1 Months', popular: true,
        description: 'etPOS with 2 Locations',
        features: ['2 Business Locations', '6 Users', 'Unlimited Products', '3000 Invoices',
            'Accounting Module', 'Max Token usage (AI Assistance)', 'Crm Module', 'Essentials Module',
            'WooCommerce Module']
    },
    {
        id: 5, name: 'Repair Store', price: '99.99', period: '1 Months', popular: false,
        description: 'Repair Store with 1 Location',
        features: ['1 Business Locations', '2 Users', '6500 Products', '1500 Invoices',
            'Accounting Module', 'Repair Module', 'WooCommerce Module']
    },
    {
        id: 6, name: 'etFood', price: '79.00', period: '1 Months', popular: false,
        description: 'restaurant',
        features: ['1 Business Locations', '5 Users', 'Unlimited Products', 'Unlimited Invoices',
            'Accounting Module', 'Manufacturing Module', 'WooCommerce Module']
    },
    {
        id: 7, name: 'CRM & HRM Only', price: '499.00', period: '1 Years', popular: false,
        description: 'CRM & HRM Only',
        badge: '100 Trial Days',
        features: ['1 Business Locations', 'Unlimited Users', 'Unlimited Products', 'Unlimited Invoices',
            'Crm Module', 'Essentials Module', 'Project Module']
    },
    {
        id: 8, name: 'Warehouse with 3 Users', price: '199.99', period: '1 Months', popular: false,
        description: 'Warehouse with 8 Drivers',
        badge: '1 Trial Days',
        features: ['1 Business Locations', '5 Users', 'Unlimited Products', '2000 Invoices',
            'Accounting Module', 'Max Token usage (AI Assistance)', 'Connector Module', 'Crm Module',
            'Essentials Module', 'WooCommerce Module']
    },
    {
        id: 9, name: 'Warehouse with 2 location and 7 usere', price: '229.00', period: '1 Months', popular: false,
        description: 'Warehouse Special',
        features: ['2 Business Locations', '7 Users', 'Unlimited Products', '3000 Invoices',
            'Accounting Module', 'AI Assistance Module', 'Max Token usage (AI Assistance)',
            'Crm Module', 'WooCommerce Module']
    }
];

const subscriptions = [
    { id: 1, package: 'etPOS', start: '08/26/2024', trial: '12/31/2024', end: '09/26/2024', price: '$ 69.99', via: 'offline', txn: '', status: 'approved', created: '08/27/2024', by: 'Dr Rahim Budhwani' },
    { id: 2, package: 'etPOS', start: '12/31/2024', trial: '02/01/2025', end: '12/31/2026', price: '$ 69.99', via: 'offline', txn: 'rb', status: 'approved', created: '01/01/2025', by: 'Dr Rahim Budhwani' },
    { id: 3, package: 'etPOS with 2 Locations', start: '10/01/2024', trial: '11/01/2024', end: '11/01/2024', price: '$ 69.99', via: 'offline', txn: 'RB', status: 'approved', created: '10/01/2024', by: 'Dr Rahim Budhwani' },
    { id: 4, package: 'etPOS with 2 Locations', start: '11/06/2024', trial: '05/31/2025', end: '12/30/2024', price: '$ 69.99', via: 'offline', txn: 'rb', status: 'approved', created: '11/06/2024', by: 'Dr Rahim Budhwani' },
];

const PackageSubscription = () => {
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [entriesCount, setEntriesCount] = useState('25');
    const [searchQuery, setSearchQuery] = useState('');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', padding: '0' }}>

            {/* ── Active Subscription ── */}
            <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', borderRadius: '12px', padding: '1.5rem', color: '#fff', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1rem', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '50%', padding: '0.6rem', display: 'flex' }}>
                        <Zap size={22} color="#facc15" />
                    </div>
                    <div>
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Active Subscription</p>
                        <h3 style={{ margin: '0.1rem 0 0', fontSize: '1.2rem', fontWeight: '700' }}>etPOS</h3>
                    </div>
                </div>
                <span style={{ background: '#22c55e', color: '#fff', borderRadius: '20px', padding: '0.25rem 0.9rem', fontSize: '0.8rem', fontWeight: '700', letterSpacing: '0.05em' }}>Running</span>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                    {[
                        { label: 'Start Date', value: '12/31/2024' },
                        { label: 'End Date', value: '12/31/2026' },
                        { label: 'Remaining', value: '298 day(s)' },
                    ].map((item, i) => (
                        <div key={i} style={{ textAlign: 'right' }}>
                            <p style={{ margin: 0, fontSize: '0.75rem', color: '#94a3b8' }}>{item.label}</p>
                            <p style={{ margin: '0.1rem 0 0', fontWeight: '700', fontSize: '0.95rem' }}>{item.value}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── All Subscriptions Table ── */}
            <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: '#1e293b' }}>All Subscriptions</h3>
                </div>
                <div style={{ padding: '1.25rem 1.5rem' }}>
                    {/* Controls */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>Show</span>
                            <select value={entriesCount} onChange={e => setEntriesCount(e.target.value)}
                                style={{ padding: '0.3rem 0.5rem', border: '1px solid #e2e8f0', borderRadius: '4px', fontSize: '0.875rem' }}>
                                <option>25</option><option>50</option><option>100</option>
                            </select>
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>entries</span>
                        </div>

                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                            {/* Export dropdown */}
                            <div style={{ position: 'relative' }}>
                                <button onClick={() => setShowExportDropdown(!showExportDropdown)}
                                    style={{ background: '#fff', color: '#64748b', border: '1px solid #e2e8f0', padding: '0.45rem 1rem', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.875rem', fontWeight: '600', cursor: 'pointer' }}>
                                    <Download size={15} /> Export <ChevronDown size={13} />
                                </button>
                                {showExportDropdown && (
                                    <div style={{ position: 'absolute', top: '110%', right: 0, background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, minWidth: '180px', padding: '0.4rem 0' }}>
                                        {[
                                            { label: 'Export CSV', icon: <FileSpreadsheet size={15} color="#10b981" /> },
                                            { label: 'Export Excel', icon: <FileSpreadsheet size={15} color="#3b82f6" /> },
                                            { label: 'Print', icon: <Printer size={15} color="#6366f1" /> },
                                            { label: 'Export PDF', icon: <FileText size={15} color="#ef4444" /> },
                                        ].map((opt, i) => (
                                            <button key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', width: '100%', padding: '0.55rem 1rem', border: 'none', background: 'none', textAlign: 'left', fontSize: '0.85rem', color: '#334155', cursor: 'pointer' }}>
                                                {opt.icon} {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{ fontSize: '0.875rem', color: '#64748b' }}>Search:</span>
                            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
                                placeholder="Search ..."
                                style={{ padding: '0.4rem 0.75rem', border: '1px solid #cbd5e1', borderRadius: '5px', fontSize: '0.875rem', outline: 'none', width: '180px' }} />
                        </div>
                    </div>

                    {/* Table */}
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
                            <thead>
                                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                    {['Package Name', 'Start Date', 'Trial End Date', 'End Date', 'Price', 'Paid Via', 'Transaction Id', 'Status', 'Created At', 'Created By', 'Action'].map((h, i) => (
                                        <th key={i} style={{ padding: '0.75rem 1rem', color: '#1e293b', fontWeight: '700', whiteSpace: 'nowrap', textAlign: 'left' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {subscriptions.map(s => (
                                    <tr key={s.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '0.75rem 1rem', color: '#334155', whiteSpace: 'nowrap' }}>{s.package}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>{s.start}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>{s.trial}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>{s.end}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#334155', fontWeight: '600', whiteSpace: 'nowrap' }}>{s.price}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b' }}>{s.via}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b' }}>{s.txn || '—'}</td>
                                        <td style={{ padding: '0.75rem 1rem' }}>
                                            <span style={{ background: '#dcfce7', color: '#16a34a', borderRadius: '20px', padding: '0.2rem 0.7rem', fontSize: '0.78rem', fontWeight: '700' }}>{s.status}</span>
                                        </td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>{s.created}</td>
                                        <td style={{ padding: '0.75rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>{s.by}</td>
                                        <td style={{ padding: '0.75rem 1rem' }}>
                                            <button style={{ background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b', borderRadius: '5px', padding: '0.3rem 0.6rem', fontSize: '0.78rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                •••
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.25rem', flexWrap: 'wrap', gap: '0.5rem' }}>
                        <span style={{ fontSize: '0.875rem', color: '#64748b' }}>Showing 1 to 4 of 4 entries</span>
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                            <button style={{ padding: '0.4rem 0.75rem', border: '1px solid #e2e8f0', background: '#fff', borderRadius: '4px 0 0 4px', fontSize: '0.85rem', color: '#a0aec0', cursor: 'not-allowed' }}>Previous</button>
                            <button style={{ padding: '0.4rem 0.75rem', border: '1px solid #334155', background: '#334155', color: '#fff', fontSize: '0.85rem' }}>1</button>
                            <button style={{ padding: '0.4rem 0.75rem', border: '1px solid #e2e8f0', background: '#fff', borderRadius: '0 4px 4px 0', fontSize: '0.85rem', color: '#a0aec0', cursor: 'not-allowed' }}>Next</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Packages ── */}
            <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '700', color: '#1e293b' }}>Packages</h3>
                </div>
                <div style={{ padding: '1.5rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))', gap: '1.25rem' }}>
                    {packages.map(pkg => (
                        <div key={pkg.id} style={{ border: pkg.popular ? '2px solid #6366f1' : '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative', boxShadow: pkg.popular ? '0 4px 20px rgba(99,102,241,0.15)' : '0 1px 3px rgba(0,0,0,0.05)' }}>
                            {pkg.popular && (
                                <div style={{ background: '#6366f1', color: '#fff', textAlign: 'center', padding: '0.35rem', fontSize: '0.75rem', fontWeight: '700', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.3rem' }}>
                                    <Star size={12} fill="#fff" /> Popular
                                </div>
                            )}
                            {pkg.badge && (
                                <div style={{ position: 'absolute', top: pkg.popular ? '2.5rem' : '0.75rem', right: '0.75rem', background: '#facc15', color: '#1e293b', borderRadius: '20px', padding: '0.2rem 0.65rem', fontSize: '0.72rem', fontWeight: '700' }}>{pkg.badge}</div>
                            )}

                            <div style={{ padding: '1.25rem', background: '#f8fafc', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                                <div style={{ background: '#ede9fe', borderRadius: '50%', width: '48px', height: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 0.75rem' }}>
                                    <Package size={22} color="#6366f1" />
                                </div>
                                <h4 style={{ margin: '0 0 0.35rem', fontSize: '1.05rem', fontWeight: '700', color: '#1e293b' }}>{pkg.name}</h4>
                                <p style={{ margin: 0, color: '#64748b', fontSize: '0.82rem' }}>{pkg.description}</p>
                            </div>

                            <div style={{ padding: '1rem 1.25rem', textAlign: 'center', borderBottom: '1px solid #f1f5f9' }}>
                                <span style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1e293b' }}>${pkg.price}</span>
                                <span style={{ color: '#94a3b8', fontSize: '0.82rem' }}> / {pkg.period}</span>
                            </div>

                            <div style={{ padding: '1rem 1.25rem', flex: 1 }}>
                                <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                    {pkg.features.map((f, i) => (
                                        <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: '#475569' }}>
                                            <CheckCircle size={14} color="#22c55e" style={{ flexShrink: 0 }} /> {f}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div style={{ padding: '1rem 1.25rem', borderTop: '1px solid #f1f5f9' }}>
                                <button style={{ width: '100%', background: pkg.popular ? '#6366f1' : '#f1f5f9', color: pkg.popular ? '#fff' : '#334155', border: 'none', borderRadius: '8px', padding: '0.65rem', fontWeight: '700', fontSize: '0.875rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.45rem' }}>
                                    <CreditCard size={16} /> Pay &amp; Subscribe
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PackageSubscription;
